import React from 'react';
import {Link as RouterLink, LinkProps as RouterLinkProps} from 'react-router-dom';
import cn from 'classnames';

import styles from './Link.module.sass';

export type LinkProps = {
  children: React.ReactNode | JSX.Element | string;
  to?: RouterLinkProps['to'];
  className?: string;
  disabled?: boolean;
  action?: boolean;
  densed?: boolean;
} & RouterLinkProps;

const defaultProps: LinkProps = {
  children: '',
  to: '/',
  action: false,
  disabled: false,
  densed: false,
  className: undefined,
};

function Link({
  children,
  disabled,
  className,
  action,
  to,
  densed,
  href,
  referrerPolicy,
  ...props
}: LinkProps) {
  return href ? (
    <a
      {...props}
      href={href}
      className={cn(className, styles.link, {
        [styles.action]: action,
        [styles.densed]: densed,
      })}
    >
      {children}
    </a>
  ) : (
    <RouterLink
      {...props}
      to={to}
      className={cn(className, styles.link, {
        [styles.action]: action,
        [styles.densed]: densed,
      })}
    >
      {children}
    </RouterLink>
  );
}

Link.defaultProps = defaultProps;

export {Link};
